import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LaunchProvider } from './contexts/LaunchContext';
import { CookieBanner } from './components/CookieBanner';
import { Home } from './pages/Home';
import { CookiePolicy } from './pages/CookiePolicy';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { Disclaimer } from './pages/Disclaimer';
import { Contact } from './pages/Contact';
import { FAQ } from './pages/FAQ';
import { About } from './pages/About';
import { DeleteAccount } from './pages/DeleteAccount';
type LaunchState = 'pre-launch' | 'public-launch';
export function App({
  launchState = 'pre-launch'
}: {
  launchState?: LaunchState;
}) {
  return <LaunchProvider launchState={launchState} data-id="element-0" data-mp="2wifc12o1ootf">
      <Routes data-id="element-1" data-mp="28u5uwe1s0p8m">
        <Route path="/" element={<Home data-id="element-3" data-mp="28suumo7jhzm9" />} data-id="element-2" data-mp="28tmdqzjya4vn" />
        <Route path="/cookie-policy" element={<CookiePolicy data-id="element-5" data-mp="23vkzcrxgytqi" />} data-id="element-4" data-mp="28sbb5328r364" />
        <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-7" data-mp="23t8h0dnsuhcx" />} data-id="element-6" data-mp="23u9q4cl98ts0" />
        <Route path="/terms" element={<TermsAndConditions data-id="element-9" data-mp="3iiwg8rrbto4t" />} data-id="element-8" data-mp="3ik7e6ay3c1o0" />
        <Route path="/disclaimer" element={<Disclaimer data-id="element-11" data-mp="3mlaxj7fckftz" />} data-id="element-10" data-mp="3ihv2gfixenje" />
        <Route path="/contact" element={<Contact data-id="element-13" data-mp="3mjq3rk0ux0x6" />} data-id="element-12" data-mp="3mkhn9wh6j873" />
        <Route path="/faq" element={<FAQ data-id="element-15" data-mp="3rbrcivytg9ig" />} data-id="element-14" data-mp="3rc9em985thya" />
        <Route path="/about" element={<About data-id="element-17" data-mp="3rd189ei755lx" />} data-id="element-16" data-mp="3rdatkosaqola" />
        <Route path="/delete-account" element={<DeleteAccount data-id="element-19" data-mp="682rygdekbl" />} data-id="element-18" data-mp="5yk6vxnnffx" />
      </Routes>
      <CookieBanner data-id="element-20" data-mp="82kl3wchwbg" />
    </LaunchProvider>;
}